import { Fragment, useEffect } from 'react'
import { StoreThunkDispatch } from 'store/state'
import {
  Stream,
  AnyContent,
  INTERACTION_EVENT_OPEN,
  ContentItem,
  RangeFilter,
  NEW_RANGE_FILTER
} from 'interfaces'
import { addRecentSource } from 'services/content/recommended/actions'
import { trackStreamInteraction } from 'services/content/streams/actions'
import { FormattedMessage } from 'react-intl'
import styles from './StreamBricksView.pcss'
import { ContentGridView } from 'components/ContentGridView'
import { useDispatch } from 'react-redux'
import { ContentType, FilterType } from 'shared'

export interface ScrollConfiguration {
  element?: Element
  useWindow?: boolean
}

export interface StreamBricksViewProps {
  stream: Stream
  filter: FilterType
  contentTypes: ContentType[]
  scroll?: ScrollConfiguration
  range?: RangeFilter
  itemWidth?: number
  onItemPinned?(stream: Stream, content: AnyContent): void
  onItemShared?(stream: Stream, content: AnyContent): void
  onGotoClicked?(stream: Stream, content: AnyContent, by: string): void
  onRangeChanged?(stream: Stream, range: RangeFilter): boolean
  onFilterChanged(filter: FilterType): void
  onContentItemClick?(item: ContentItem): void
}

export function StreamBricksView(props: StreamBricksViewProps) {
  const { stream, filter, scroll, range, itemWidth, contentTypes } = props
  const dispatch = useDispatch<StoreThunkDispatch>()

  useEffect(() => {
    dispatch(trackStreamInteraction({ streamIds: [stream.id], event: INTERACTION_EVENT_OPEN }))
      .unwrap()
      .then(() => {
        dispatch(addRecentSource(stream))
      })
  }, [dispatch, stream])

  const onItemPinned = (content: AnyContent) => {
    if (props.onItemPinned) {
      props.onItemPinned(stream, content)
    }
  }

  const onItemShared = (content: AnyContent) => {
    if (props.onItemShared) {
      props.onItemShared(stream, content)
    }
  }

  const onGotoClicked = (content: AnyContent, by: string) => {
    if (props.onGotoClicked) {
      props.onGotoClicked(stream, content, by)
    }
  }


  const onFeedClicked = (content: AnyContent) => {
    onGotoClicked(content, 'attribution')
  }

  const onRangeChanged = (range: RangeFilter): boolean => {
    if (props.onRangeChanged) {
      return props.onRangeChanged(stream, range)
    }
    return false
  }

  return (
    <Fragment>
      {range === NEW_RANGE_FILTER && (
        <div className={styles['msg-range']}>
          <h5 className={styles['msg-title']}>
            <FormattedMessage id="content.msg.stream-range-new-title" />
          </h5>
          <p className={styles['msg-subtitle']}>
            <FormattedMessage id="content.msg.stream-range-new-subtitle" />
          </p>
        </div>
      )}
      <ContentGridView
        key="content"
        sourceId={stream.originalId || stream.id}
        filter={filter}
        scroll={scroll}
        range={range}
        itemWidth={itemWidth}
        contentTypes={contentTypes}
        isStream={true}
        sourcesHash={stream.slug + ''}
        preventTopOverflow={true}
        onFilterChange={props.onFilterChanged}
        onRangeChanged={onRangeChanged}
        onItemShared={onItemShared}
        onItemPinned={onItemPinned}
        onSourceClick={onGotoClicked}
        onFeedClick={onFeedClicked}
        onContentItemClick={props.onContentItemClick}
      />
    </Fragment>
  )

}

export default StreamBricksView
